var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIc16Close(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "16x16 / ic16-close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41425 8.00025L12.7072 4.70725C13.0982 4.31625 13.0982 3.68425 12.7072 3.29325C12.3162 2.90225 11.6842 2.90225 11.2933 3.29325L8.00025 6.58625L4.70725 3.29325C4.31625 2.90225 3.68425 2.90225 3.29325 3.29325C2.90225 3.68425 2.90225 4.31625 3.29325 4.70725L6.58625 8.00025L3.29325 11.2933C2.90225 11.6842 2.90225 12.3162 3.29325 12.7072C3.48825 12.9022 3.74425 13.0002 4.00025 13.0002C4.25625 13.0002 4.51225 12.9022 4.70725 12.7072L8.00025 9.41425L11.2933 12.7072C11.4882 12.9022 11.7443 13.0002 12.0002 13.0002C12.2562 13.0002 12.5122 12.9022 12.7072 12.7072C13.0982 12.3162 13.0982 11.6842 12.7072 11.2933L9.41425 8.00025Z",
    fill: "#7256CE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc16Close);
export default __webpack_public_path__ + "static/media/ic16-close.ef873e840655d1b1c55923484c1dbfdc.svg";
export { ForwardRef as ReactComponent };